module.exports = __webpack_public_path__ + "img/lyman-beecher.4aa66cc9.png";